import _CardContent from "@mui/material/CardContent";
import _Card from "@mui/material/Card";
import _CardHeader from "@mui/material/CardHeader";
import _ArrowDownward from "@mui/icons-material/ArrowDownward";
import _Skeleton from "@mui/material/Skeleton";
import _ArrowUpward from "@mui/icons-material/ArrowUpward";
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { ElevationsChart } from './elevations-chart';
export function ElevationsChartCard({
  disableElevation,
  route,
  setChart,
  onHighlight
}) {
  return /*#__PURE__*/React.createElement(_Card, {
    sx: {
      borderRadius: 2
    },
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(_CardHeader, {
    slotProps: {
      subheader: {
        component: 'div',
        variant: 'body2'
      },
      title: {
        component: 'div',
        variant: disableElevation ? 'body1' : 'h6'
      }
    },
    subheader: /*#__PURE__*/React.createElement(StyledSubheader, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_ArrowUpward, {
      fontSize: "small"
    }), route ? /*#__PURE__*/React.createElement(React.Fragment, null, Math.round(route.verticalGain), " m") : /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: 50
    })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_ArrowDownward, {
      fontSize: "small"
    }), route ? /*#__PURE__*/React.createElement(React.Fragment, null, Math.round(route.verticalLoss), " m") : /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: 50
    }))),
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.routing.detail.elevation_profile"
    })
  }), /*#__PURE__*/React.createElement(StyledCardContent, null, /*#__PURE__*/React.createElement(ElevationsChart, {
    onHighlight: onHighlight,
    route: route,
    setChart: setChart
  })));
}
const StyledSubheader = styled.span`
  display: flex;

  > span {
    align-items: center;
    display: flex;

    svg {
      margin-right: 8px;
    }

    &:not(:first-child) {
      margin-left: 16px;
    }
  }
`;
const StyledCardContent = styled(_CardContent)`
  && {
    padding: 16px;
  }
`;